// extracted by mini-css-extract-plugin
export default {"root":"CourseRulesMobile_root__ZuV4R","table":"CourseRulesMobile_table__7BbL+","desp":"CourseRulesMobile_desp__q03jF"};